import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.364 9.905v-3.81h.77v3.81zM9.067 7.964q0 .94-.512 1.44-.51.5-1.475.5H6.05V6.096h1.142q.89 0 1.383.493.492.492.492 1.376m-.8.02q0-1.227-1.036-1.227h-.41v2.48h.33q1.116 0 1.115-1.253"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.299 1.393c-.387 0-.7.329-.7.734v3.666h-3.5c-.387 0-.7.329-.7.734s.313.733.7.733h4.2c.387 0 .7-.328.7-.733v-4.4c0-.405-.313-.734-.7-.734",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.575.738a6.73 6.73 0 0 0-4.362.844 7.2 7.2 0 0 0-3.002 3.421 7.66 7.66 0 0 0-.437 4.624 7.4 7.4 0 0 0 2.304 3.971 6.83 6.83 0 0 0 4.12 1.723 6.76 6.76 0 0 0 4.28-1.216 7.3 7.3 0 0 0 2.724-3.668c.129-.382-.063-.8-.427-.935a.69.69 0 0 0-.893.448 5.84 5.84 0 0 1-2.18 2.934 5.4 5.4 0 0 1-3.424.973 5.46 5.46 0 0 1-3.295-1.378A5.92 5.92 0 0 1 2.14 9.302a6.12 6.12 0 0 1 .349-3.7 5.77 5.77 0 0 1 2.402-2.736 5.4 5.4 0 0 1 3.49-.675 5.5 5.5 0 0 1 3.19 1.673L14.82 7.06a.68.68 0 0 0 .99-.032.76.76 0 0 0-.032-1.037l-3.24-3.19A6.9 6.9 0 0 0 8.575.738",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })